import React from 'react'

const StudentFeeReportsFormCreateView = () => {
  return (
    <div>StudentFeeReportsFormCreateView</div>
  )
}

export default StudentFeeReportsFormCreateView